import { createRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { motion } from "motion/react";
import { Button, Modal } from "../../shared/ui/index.js";
import { QuoteForm } from "./QuoteForm.js";
import { rootRoute } from "../../app/root-route.js";

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: LandingScreen,
});

const STEPS = [
  ["1", "On prépare votre espace", "Nous créons votre mariage, vos événements et votre thème."],
  ["2", "Vos invités scannent le QR", "Photos et vidéos depuis leur téléphone, sans application."],
  ["3", "La galerie se dévoile", "Le lendemain, tout apparaît. Une surprise, puis un album."],
] as const;

function LandingScreen() {
  const [quote, setQuote] = useState(false);

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-[#fffdf8]">
      <div className="flex items-center justify-between px-6 pt-6">
        <p className="text-xs uppercase tracking-[0.3em] text-stone-400">par SmartRiver</p>
        <Link to="/login" className="text-xs text-stone-500 underline">
          Espace client
        </Link>
      </div>

      <div className="flex flex-1 flex-col justify-center px-6">
        <div className="mx-auto w-full max-w-2xl">
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif text-5xl text-stone-900 sm:text-6xl"
          >
            SmartVow
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="mt-4 max-w-lg text-lg text-stone-600"
          >
            La galerie photo &amp; vidéo de vos invités — une surprise pour les mariés, dévoilée
            le lendemain.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mt-8 grid gap-4 sm:grid-cols-3"
          >
            {STEPS.map(([n, t, d]) => (
              <div key={n} className="flex flex-col gap-1.5">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-rose-100 font-serif text-rose-800">
                  {n}
                </span>
                <p className="text-sm font-medium text-stone-900">{t}</p>
                <p className="text-xs text-stone-500">{d}</p>
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="mt-8"
          >
            <Button onClick={() => setQuote(true)}>Demander un devis</Button>
          </motion.div>
        </div>
      </div>

      <footer className="shrink-0 py-5 text-center text-xs text-stone-400">
        SmartVow — par SmartRiver
      </footer>

      {quote && (
        <Modal title="Demander un devis" onClose={() => setQuote(false)}>
          <QuoteForm onDone={() => setQuote(false)} />
        </Modal>
      )}
    </div>
  );
}
